/**
 * Resolve a block's live DOM node so an inline surface can anchor to it.
 * Block renderers attach `data-block-id` (the gutter); an inline element such as a chord has no gutter and is
 * found by its `data-element-id` (GH #2662). Returns null when the element is not mounted (the surfaces fall back
 * to a plain/selection render).
 */
export const resolveBlockAnchorEl = (blockId: string | undefined): HTMLElement | null => {
  if (!blockId || typeof document === 'undefined') {
    return null
  }
  const escaped = typeof CSS !== 'undefined' && typeof CSS.escape === 'function' ? CSS.escape(blockId) : blockId
  return (
    document.querySelector<HTMLElement>(`[data-block-id="${escaped}"]`) ??
    document.querySelector<HTMLElement>(`[data-element-id="${escaped}"]`)
  )
}
